export default {"src":"/uk/_next/static/media/mobileChecklistIcon.dfbbc8b3.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};